var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-button",
        {
          directives: [
            {
              name: "permission",
              rawName: "v-permission",
              value: "users.create",
              expression: "'users.create'"
            },
            {
              name: "ripple",
              rawName: "v-ripple.400",
              value: "rgba(255, 255, 255, 0.15)",
              expression: "'rgba(255, 255, 255, 0.15)'",
              modifiers: { "400": true }
            }
          ],
          attrs: { variant: "primary" },
          on: { click: _vm.addNew }
        },
        [
          _c("feather-icon", {
            staticClass: "mr-50",
            attrs: { icon: "PlusIcon" }
          }),
          _c("span", { staticClass: "align-middle" }, [
            _vm._v(_vm._s(_vm.$t("AddNew")))
          ])
        ],
        1
      ),
      _c("Grid", { attrs: { service: _vm.service, route_name: "users" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }